<template>
	<nk-dropdown v-model="dropdownValue" :data="dropdownData" :options="settings.dropdownOptions" :disabled="disabled ? true : null" ref="input" :tabindex="tabindex"></nk-dropdown>
</template>
<script>
	import _ from 'lodash'
	import { mapGetters } from 'vuex'
	import $sc from '~/plugins/shortcut.collection.js'
	import bankSelector from '~/views/treasury/bank-selector'

	export default {
		props: {
			data: { type: Array, deafult: () => [] },
			modelValue: {},
			options: {},
			tabindex: {},
			disabled: { type: Boolean, default: false }
		},
		emits: ['update:modelValue'],
		data() {
			return {
				settings: {
					dropdownOptions: {
						rowIdentifier: 'id',
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						selectorWidth: 'auto',
						searchableFields: ['name'],
						findExactMatch: this.findExactMatch,
						display: function (item) {
							let name = item.name || ''
							let regx = /^[a-zA-Z].+/g
							if (name.search(regx) > -1) {
								let resourceName = 'bank.' + name
								let tname = this.$t(resourceName)
								if (tname === resourceName) {
									return name
								} else {
									return tname
								}
							} else {
								return name
							}
						},
						buttons: [
							{
								title: this.$t('bank.management'),
								shortcut: $sc.find('enter'),
								isPrimary: true,
								element: () => { return this.$el },
								icon: 'list-ul',
								handle: (button, page, e) => {
									this.showBanks()
								},
							},
						],
					},
				},
				localValue: null,
			}
		},
		computed: {
			...mapGetters({
				bank_all: 'banks/all',
			}),
			dropdownValue: {
				get() {
					return this.localValue
				},
				set(val) {
					this.$emit('update:modelValue', val)
					this.localValue = val
				},
			},
			dropdownData() {
				return this.data && this.data.length ? this.data : this.bank_all.filter(x => x.isEnabled)
			},
		},
		watch: {
			modelValue: {
				handler(val, oldVal) {
					this.localValue = val
				},
			},
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.extend({}, this.settings, val)
				},
			},
		},
		created() {
			this.localValue = this.modelValue
		},
		mounted() { },
		methods: {
			showBanks() {
				var that = this
				this.showModal({ component: bankSelector, data: null }).then(function (
					result
				) {
					that.dropdownValue = result
					that.$refs.input.focusAndSelect()
				}).catch(x => { })
			},
		},
	}
</script>
<style></style>
